import React, { Component } from "react"
import NewsCard from "./NewsCard"

import "./InTheNews.scss"

const InTheNews = () => {
  return (
    <div className="news-cards-frame">
      <NewsCard
        textColor="#242424"
        borderColor="#3f3f3f"
        bgColor="#ECECEC"
        url="https://www.forbes.com/sites/martingiles/2020/03/20/five-things-to-expect-cio-it-budgets-coronavirus/?ss=cio-network#109faf8f49b1"
        imageUrl="https://prod-etr.s3.amazonaws.com/uploads/images/forbes.png"
        text={
          "Five Things To Expect From Cuts In CIOs’ Tech Budgets Due To COVID-19"
        }
      />

      <NewsCard
        textColor="#454646"
        borderColor="#0088c2"
        bgColor="#E5F3F8"
        url="https://wikibon.com/covid-19-it-spending-impact-march-26-2020/"
        imageUrl="https://prod-etr.s3.amazonaws.com/uploads/images/theCube.png"
        text={"COVID-19 IT Spending Impact - March 26 , 2020"}
      />

      <NewsCard
        textColor="#000000"
        borderColor="#000000"
        bgColor="#fff"
        url="https://www.wsj.com/articles/amazon-microsoft-tighten-grip-on-enterprise-tech-11552949379"
        imageUrl="https://dev-etr.s3.amazonaws.com/images/icons/WSJ.png"
        text={
          "WSJ cites ETR Survey results - Amazon, Microsoft Tighten Grip on Enterprise Tech"
        }
      />

      <NewsCard
        textColor="#1B2C5B"
        borderColor="#1e3165"
        bgColor="#E9EAF0"
        url=" https://battleofthequants.com/data-awards-info/"
        imageUrl="https://dev-etr.s3.amazonaws.com/images/icons/battleOftheQuant.png"
        text={
          'ETR wins the "Earner Award" for Best Medium Frequency Dataset in the <span style="color:#2f87d0;font-style:italic;">Battle of the Quants</span> '
        }
      />

      <NewsCard
        textColor="#1B2328"
        borderColor="#1e272c"
        bgColor="#E9E9EA"
        url="https://bloomberg.cwebcast.com/ses/xrHl8-XlgfpwakHEfsKU5Q~~?ek=2d1780b6-2ba5-41ca-b060-bfeb9a7e8c15"
        imageUrl="https://dev-etr.s3.amazonaws.com/images/icons/bloomberg.png"
        text={
          "ETR formally launches partnership with Bloomberg as alternative data provider"
        }
      />
    </div>
  )
}
export default InTheNews
